import React from 'react';
import { SecondaryButton } from 'ui/button';
import noop from 'utils/noop';
import ToggleColumnsModal from './ToggleColumnsModal';
import {
  ActionsContainer,
  ContentContainer,
  FilterContainer,
  ToolbarContainer,
} from './Toolbar.styled';

// type Props = {
//   /** Additional classes. */
//   className: string,
//   /** Columns of the table. */
//   columns: [],
//   /** Additioanl content to show in the toolbar. */
//   content: node,
//   /** Filter Input to show. */
//   filterInput: node,
//   /** If buttons are iterable table style. */
//   isTableButtonStyle: boolean,
//   /** If the left-most column is docked. */
//   leftColumnDocked: boolean,
//   /** If toggle columns button is visible. */
//   showToggleColumns: boolean,
//   /** Callback when modal is opened. */
//   onOpenToggleModal: () => void,
//   /**
//    * Callback function when visible columns value changes.
//    *
//    * ```
//    * onToggleColumns(e, visibleColumnsProps) => {}
//    * ```
//    * @param { Object } e: The change event.
//    * @param { Object } visibleColumnsProps: New `visibleColumns` prop { visibleColumns }.
//    * @returns { void }
//    */
//   onToggleColumns: (e: {}, visibleColumnsProps: {}) => {},
//   /** Content to display over the row. */
//   overlayContent: node,
//   /** Additional paging controls to show. */
//   pagingControls: node,
//   /** Currently visible columns. */
//   visibleColumns: [],
// };

export default class Toolbar extends React.Component {
  static defaultProps = {
    onOpenToggleModal: noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      openToggleColumnsModal: false,
    };
  }

  /**
   * handleOpen
   * Callback function when toggle columns modal opens.
   * @returns { void }
   */
  handleOpen = () => {
    this.props.onOpenToggleModal();
    this.setState({ openToggleColumnsModal: true });
  };

  /**
   * handleClose
   * Callback function when toggle columns modal closes.
   * @returns { void }
   */
  handleClose = () => {
    this.setState({ openToggleColumnsModal: false });
  };

  /**
   * handleSave
   * Callback function when toggle columns modal changes visible columns.
   * @param { Object } e: The click event.
   * @param { Object } updatedProps: The updated props containing updated visibleColumns value.
   * @returns { void }
   */
  handleSave = (e, updatedProps) => {
    const { onToggleColumns } = this.props;
    onToggleColumns(e, updatedProps);
    this.setState({ openToggleColumnsModal: false });
  };

  render() {
    const {
      showToggleColumns,
      className,
      content,
      columns,
      filterInput,
      isTableButtonStyle,
      leftColumnDocked,
      overlayContent,
      pagingControls,
      visibleColumns,
    } = this.props;
    return (
      <ToolbarContainer
        $isIterableStyle={isTableButtonStyle}
        $hasOverlay={overlayContent}
        className={className}
        data-role="toolbar"
      >
        {overlayContent}
        <ContentContainer>{content}</ContentContainer>
        <ActionsContainer>
          {pagingControls}
          {showToggleColumns && (
            <SecondaryButton onClick={this.handleOpen}>Customize Columns</SecondaryButton>
          )}
          {showToggleColumns && (
            <ToggleColumnsModal
              columns={columns}
              leftColumnDocked={leftColumnDocked}
              open={this.state.openToggleColumnsModal}
              onClose={this.handleClose}
              onSave={this.handleSave}
              visibleColumns={visibleColumns}
            />
          )}
          {filterInput && <FilterContainer>{filterInput}</FilterContainer>}
        </ActionsContainer>
      </ToolbarContainer>
    );
  }
}
